import { createContext, useState } from 'react';
import api from 'services/api';

export const ArmazenagemContext = createContext();

export const ArmazenagemProvider = ({ children }) => {
  const [documentosLoading, setdocumentosLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [lotesLoading, setLotesLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [getLoading, setGetLoading] = useState(false);

  const getDocumentos = async ({ params = {}, cb = null }) => {
    try {
      setdocumentosLoading(true);
      const { data } = await api.get('/WMS/Armazenagem/Documentos', { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setdocumentosLoading(false);
    }
  };

  const getLotes = async ({ params = {}, cb = null }) => {
    try {
      setLotesLoading(true);
      const { data } = await api.get('/WMS/Armazenagem/Lotes', { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setLotesLoading(false);
    }
  };

  const getLote = async ({ id, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get(`/WMS/Armazenagem/Lote/${id}`);
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getConferencia = async ({ params = {}, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/WMS/Armazenagem/Conferencia', {
        params,
      });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postConferencia = async ({ data = {}, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post('/WMS/Armazenagem/Conferencia', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const deleteConferencia = async ({ params, cb }) => {
    try {
      setDeleteLoading(true);
      await api.delete('/WMS/Armazenagem/Conferencia', { params });
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  const postLote = async ({ data = {}, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post('/WMS/Armazenagem/Lote', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const deleteItensLote = async ({ data, cb }) => {
    try {
      setDeleteLoading(true);
      await api.post('/WMS/Armazenagem/DeleteItens', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  const getArmazenagem = async ({ params = {}, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/WMS/Armazenagem', {
        params,
      });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postConcluir = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post('/WMS/Armazenagem/Concluir', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postArmazenagem = async ({ data, cb = null, cbError = null }) => {
    try {
      setPostLoading(true);
      await api.post('/WMS/Armazenagem', data);
      if (cb) {
        cb();
      }
    } catch (error) {
      if (cbError) {
        cbError();
      }
    } finally {
      setPostLoading(false);
    }
  };

  const getEtiqueta = async ({ params = {}, cb = null, cbError = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/WMS/Armazenagem/Etiqueta', { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
      if (cbError) {
        cbError();
      }
    } finally {
      setGetLoading(false);
    }
  };

  const deleteItensArm = async ({ data, cb }) => {
    try {
      setDeleteLoading(true);
      await api.post('/WMS/Armazenagem/Delete', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  const postEtiquetas = async ({ data, cb }) => {
    try {
      setPostLoading(true);
      const { data: dt } = await api.post('/WMS/Armazenagem/Etiqueta', data, {
        responseType: 'blob',
      });
      const file = new Blob([dt], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  return (
    <ArmazenagemContext.Provider
      value={{
        documentosLoading,
        getDocumentos,
        lotesLoading,
        getLotes,
        getLote,
        getLoading,
        getConferencia,
        postLoading,
        postConferencia,
        deleteLoading,
        deleteConferencia,
        postLote,
        deleteItensLote,
        getArmazenagem,
        postConcluir,
        postArmazenagem,
        getEtiqueta,
        deleteItensArm,
        postEtiquetas,
      }}
    >
      {children}
    </ArmazenagemContext.Provider>
  );
};
